import { render } from "./TagConsentMonitoringWidget.vue?vue&type=template&id=665cab6d&scoped=true"
import script from "./TagConsentMonitoringWidget.vue?vue&type=script&lang=js"
export * from "./TagConsentMonitoringWidget.vue?vue&type=script&lang=js"

import "./TagConsentMonitoringWidget.vue?vue&type=style&index=0&id=665cab6d&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-665cab6d"]])

export default __exports__